import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)
const store = new Vuex.Store({
  state: { solutionindustry:0 },
  mutations: {
    setSolutionIndustry(state,index){//调用方式 this.$store.commit('setSolutionIndustry', index)
        if(index>=0){
            state.solutionindustry=index;
        }
    },
    resetSolutionIndustry(state){
        state.solutionindustry=0;
    }
  },
  getters: { 
    getSolutionIndustry:(state)=>()=>{//调用方式 this.$store.getters.getPermission('sys_User')
        return state.solutionindustry;
    }

  },
    
  actions: {
    
    
  }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js